// ClaimsProcessingFilters.js
import React from 'react'
import { DoneAll, RestartAlt, Restore } from '@mui/icons-material'
import CustomButton from '../../shared/CustomButton'
import { useTranslation } from 'react-i18next'

const ClaimsProcessingFilters = ({ filters, onChange, onApply }) => {
  const { t } = useTranslation()

  return (
    <form
      className='space-y-4 '
      onSubmit={e => {
        e.preventDefault()
        onApply()
      }}
    >
      {[
        { name: 'vatInvoice', label: 'VAT Invoice', type: 'text' },
        { name: 'mobile', label: 'Mobile', type: 'text' },
        { name: 'policyNumber', label: 'Policy Number', type: 'text' },
        { name: 'membership', label: 'Membership', type: 'text' },
        { name: 'episodeNumber', label: 'Episode Number', type: 'text' }
      ].map(field => (
        <div key={field.name} className='flex flex-col'>
          <label className='text-sm font-medium text-gray-700 mb-1'>
            {t(field.label)}
          </label>
          <input
            placeholder={t(`Enter ${field.label}`)}
            type={field.type}
            name={field.name}
            value={filters[field.name]}
            onChange={onChange}
            className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
          />
        </div>
      ))}

      <div className='flex flex-col'>
        <label className='text-sm font-medium text-gray-700 mb-1'>
          {t('Episode Type')}
        </label>
        <select
          name='episodeType'
          value={filters.episodeType}
          onChange={onChange}
          className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
        >
          <option value=''>{t('Select episode type')}</option>
          <option value='inpatient'>{t('Inpatient')}</option>
          <option value='outpatient'>{t('Outpatient')}</option>
          <option value='emergency'>{t('Emergency')}</option>
        </select>
      </div>

      <div className='flex flex-col'>
        <label className='text-sm font-medium text-gray-700 mb-1'>
          {t('Date')}
        </label>
        <input
          type='date'
          name='date'
          value={filters.date}
          onChange={onChange}
          className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
        />
      </div>
      <div className='flex flex-col items-center gap-2'>
        <CustomButton
          label={t('Reset Filters')}
          className='w-full  !bg-gray-500 !text-white'
          icon={<RestartAlt />}
          variant='outlined'
          type='button'
        />
        <CustomButton
          label={t('Apply Filters')}
          className='w-full '
          icon={<DoneAll />}
          type='submit'
        />
      </div>
    </form>
  )
}

export default ClaimsProcessingFilters
